import { FC } from "react";

interface DeclineCrossSVGProps {
    className?: string;
}

const DeclineCrossSVG: FC<DeclineCrossSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.5 1L1.5 15M1.50005 1L15.5 15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default DeclineCrossSVG;
